import axios from 'axios'

export function login(email, password) {
    return new Promise((resolve, reject) => {
      axios.post(process.env.REACT_APP_URL_API_SERVER_LOGIN, {
        email, password
      })
        .then(res => {
          if (res.data.esito === 'OK') resolve(res.data)
          if (res.data.esito === 'KO') reject(res.data)
        })
        .catch(error => reject(error))
    })
  }

  export function backendRequest(body, classe, metodo) {
    return new Promise((resolve, reject) => {
      axios.post(process.env.REACT_APP_URL_API_SERVER, body,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
          organizzazione: JSON.parse(sessionStorage.getItem('activeAgency')).value,
          classe,
          metodo,
          ACL: ''
        }
      })
        .then(res => {
          if (res.data.esito === 'OK') resolve(res.data)
          
        })
        .catch(e => reject(e))
    })
  }

  export function changePasswordProfile(body) {
    return new Promise((resolve, reject) => {
      axios.post(process.env.REACT_APP_URL_API_SERVER_CHANGE_PASSWORD, body,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`
        }
      })
        .then(res => {
          if (res.data.esito === 'OK') resolve(res.data)
          
        })
        .catch(() => { if (res.data.esito === 'KO') reject(res.data) })
    })
  }